import React, { useState, useEffect } from 'react';
import './home.css';
import  Logo from './C2.jpg';
import { Button, Container, Row , Col } from 'reactstrap';
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import SpeechRecognition, { useSpeechRecognition } from 'react-speech-recognition';
import axios from "axios";
import { useSpeechSynthesis } from 'react-speech-kit';
import Microphone from './microphoneimage.png'


const Home = (props) => {
  
  const {
    transcript,
    interimTranscript,
    finalTranscript,
    resetTranscript,
    listening
  } = useSpeechRecognition()
  
  const [voiceString, setVoiceString] = useState('');
  const [speechString, setSpeechString] = useState('');
  const [messageToShow, setMessageToShow] = useState('Please Click on Start Button...');
  const [flag, setFlag] = useState(false);
  const { speak } = useSpeechSynthesis();
  useEffect(() => {
    if (finalTranscript ) {
      console.log('Got final result:', finalTranscript);
      setVoiceString(finalTranscript);
      setMessageToShow(finalTranscript);
      
    }
    
    
  }, [finalTranscript])

  useEffect(() => {
    if(!flag) {
      setMessageToShow('Please Click on Start Button...')
    }
    else {
      setMessageToShow('Listening...')
    }
    
  }, [flag])
  
  
  useEffect(() => {
    initiateVoiceAssistance(voiceString);
  }, [voiceString])

  useEffect(() => {
    SpeechRecognition.abortListening();
   
    speak({ text: speechString });
    console.log("=======speech string========",speechString)
    let time = speechString.length*73;
    
    
    setTimeout(() => {
      
      if(flag) {
        
        SpeechRecognition.startListening();
        setMessageToShow("Listening...");
        
        
      }
      
    },time);
    
    console.log("=======time========",time)
    resetTranscript();
  }, [speechString]);

  /* useEffect(() => {
    if(transcript === ') {
      setMessageToShow("Please Click on Start Button...");
    }
  }, [transcript]) */

  const initiateVoiceAssistance = () => {
    
    axios.get('https://hope-backend-new2024.onrender.com/'+voiceString)
    .then(function (response) {
      console.log(response);
      if(response.data.url) {
        window.open(response.data.url);
        setFlag(false)
        SpeechRecognition.abortListening();
      }
      setSpeechString(response.data.data) 
       
    })
    .catch(function (error) {
      setSpeechString("Sorry I don't understand that.")
      console.log(error);
    })
  }

  return (
    <>
    <Container fluid>
      <div >
      
      <Row className="pt-5 pl-5 pr-5">
          <div className="col ">
          <h1>Hello!! My name is Hope and Nice to meet you.</h1>
          <h5>Your sweet and cute voice assistant. If you need any help I am always
            here to help you&#128512;.
            <br/>
            Just press the button below.
            <Button className="rounded-circle bg-light my-5 mr-2"   style={{marginLeft:'4rem'}} onClick={() => {setFlag(!flag);SpeechRecognition.abortListening();SpeechRecognition.startListening({ continuous: false });}} /* onClick={SpeechRecognition.startListening} */>
            <img src={Microphone} style={{ width: "100px", height: "100px", borderRadius: "50%"}}></img></Button>{' '}
            {messageToShow &&
            
            <div className="d-block speech-bubble  "  style={{ width: "fit-content", height: "50px",padding: "5px"}}>&nbsp;{messageToShow}&nbsp;
            </div>}
          </h5>
          </div>
          <div className="col">
          <img src="https://bit.ly/3qIOVVd" style={{ width: "60vw", height: "60vh"}}></img>
          </div>
          
      </Row>
      <hr style={{border:'5px solid #1967d2' , width:'100%' , margin:'0px'}}/>
      <Row className="pt-5 pl-5 pr-5">
        <Col>
          <img src={Logo} style={{ width: "60vw", height: "60vh"  }}></img>
        </Col>
        <Col className="p-5">
          <h1>Description-</h1>
          <h5>Hope is your virtual assistant which can do some of your tasks at your 
            voice command. It can do a lot of tasks like doing calculations, answering questions,
            giving news, acts like Dictionary, general talking and a lot more.
            You can find more details at our feature section.</h5>
          </Col>
      </Row>
      <hr style={{border:'5px solid #1967d2' , width:'100%' , margin:'0px'}}/>
      <Row className="pt-5 pl-5 pr-5">
          <Col>
            <h1>Why Hope?</h1>
            <h5>We have Google Assistant, Siri and Alexa on mobile devices, but none of them is available on desktop and also we have to download apps for them.
            But Hope is also available in desktop form too. It is not as smart as them, but it is getting more smarter with time.
            </h5>
          </Col>
          <Col>
            <img src="https://bit.ly/3qS5fDn" style={{width: "60vw", height: "60vh"}}></img>
          </Col>
      </Row>    
      
      </div>
    </Container>
   <footer className="bg-secondary text-center text-lg-start">
 
   <div className="text-center p-3 text-white" >
    Created and Designed by Sakshi Maheshwari
   </div>
   
 </footer>


</>
);
}
 

 
export default Home;





